@if (visible$ | async) {
    <fieldset [formGroup]="valueGroup">
        <ng-container *ngrxLet="valueFunctionalElement$; let valueFunctionalElement">
            @if (valueFunctionalElement.choices) {
                <div class="row">
                    <p class="col-sm-9 col-12" [innerHTML]="valueFunctionalElement.description"></p>
                    <span class="text-end col-sm-3 col-12 text-end filter-text">{{ elementTypeLabel$ | async }}</span>
                </div>
            }
            <label class="col-form-label" for="{{ valueFunctionalElement.id }}">{{
                valueFunctionalElement.label
            }}</label>
            @if (valueFunctionalElement.expectedValueText) {
                <span class="col-form-label"> {{ valueFunctionalElement.expectedValueText }}</span>
            }
            <div class="row mb-3">
                <div class="col-8 col-lg-3">
                    <div [class.input-group]="!!valueFunctionalElement.unit">
                        <input
                            class="form-control input-md value-input"
                            id="{{ valueFunctionalElement.id }}"
                            [formControl]="inputFieldControl"
                            [attr.inputmode]="inputMode$ | async"
                            [ngClass]="{ 'validator-error': inputFieldControl.invalid }"
                            [placeholder]="placeholder$ | async"
                            (input)="validateNumberValue($event)"
                        />
                        @if (!!valueFunctionalElement.unit) {
                            <span class="input-group-text">{{ valueFunctionalElement.unit }}</span>
                        }
                    </div>
                </div>
                @if (displayNACheckbox$ | async) {
                    <div class="col-auto text-center">
                        <div class="not-applicable">
                            <div class="checkbox-container">
                                <input
                                    type="checkbox"
                                    id="{{ valueFunctionalElement.id }}-not-applicable"
                                    class="form-control"
                                    [formControl]="checkboxControl"
                                    [placeholder]="placeholder$ | async"
                                />
                                <label for="{{ valueFunctionalElement.id }}-not-applicable">
                                    @if (checkboxControl.value) {
                                        <fa-icon [icon]="faCheck" size="2x"></fa-icon>
                                    }
                                </label>
                            </div>
                            <label
                                translate="F4M_NOT_APPLICABLE_LABEL"
                                for="{{ valueFunctionalElement.id }}-not-applicable"
                            ></label>
                        </div>
                    </div>
                }
                @if (displayHistoryButton$ | async) {
                    <div class="col-auto ms-auto d-flex align-items-center">
                        <pace-forms-history-button
                            [uniqueId]="valueFunctionalElement.uniqueId"
                        ></pace-forms-history-button>
                    </div>
                }
            </div>
            @if (showRemarksField$ | async) {
                <div class="row mb-3">
                    <div class="col">
                        <pace-forms-input-text
                            [id]="valueFunctionalElement.remarksXmlId"
                            [label]="valueFunctionalElement.remarksLabel"
                            [formControl]="remarksControl"
                        ></pace-forms-input-text>
                    </div>
                </div>
            }
        </ng-container>
    </fieldset>
}
